import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import Row from '../components/Row';
import Button from '@mui/joy/Button';
import { getCheckoutURL } from '../services/stripe';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom/dist';
import Notification from '../services/notification';
import Typography from '@mui/joy/Typography';
import { Box } from '@mui/system';
import './Checkout.css';
import { createTracker } from '../utils/log';

const Checkout = (props) => {
    const [buttonTitle, setButtonTitle] = useState('Checkout with Stripe');
    const [disableButton, setDisableButton] = useState(false);
    const { cart, setCart, andee, sessionInfo } = useAppContext();
    const { popularTagIsPresent } = useAppContext();
    const navigate = useNavigate();
    const trackEvent = createTracker(andee, sessionInfo);

    useEffect(() => {
        setDisableButton(!!popularTagIsPresent);
    }, [popularTagIsPresent]);

    useEffect(() => {
        if (!cart.tags || !cart.total) {
            navigate('/marketplace');
        }
    }, [cart, navigate]);

    useEffect(() => {
        trackEvent('page_view', { page_name: 'checkout' });
        // Check to see if this is a redirect back from Checkout
        const query = new URLSearchParams(window.location.search);

        if (query.get('canceled')) {
            trackEvent('checkout', { status: 'canceled' });
            setButtonTitle('Checkout with Stripe');
            Notification.warning('Order canceled');
        }
    }, []);

    const handleCheckoutButton = async () => {
        trackEvent('checkout', { status: 'button_clicked' });
        setDisableButton(true);
        trackEvent('checkout', { status: 'started' });
        setButtonTitle('Processing...');
        const checkoutUrl = await getCheckoutURL(cart, setCart);
		window.location.assign(checkoutUrl);
    };

    return (
        <Box>
            <Box>
                <Row flexDirection="column">
                    <Button
                        onClick={handleCheckoutButton}
                        startDecorator={<FontAwesomeIcon icon={faLock} />}
                        disabled={disableButton}
                    >{buttonTitle}</Button>
                    <Typography level="body2">Complete your purchase safely and securely with <a href='https://stripe.com/' target={'_blank'} rel="noreferrer">Stripe</a>. Once payment is successful, you'll be redirected back here. If you run into any issues, please <a>contact us.</a></Typography>
                </Row>
                {/* </div> */}
            </Box>
        </Box>
    );
};

export default Checkout;